module.exports = __webpack_public_path__ + "media/ROOM15sec.a880960b.webm";